import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MemberService } from '../member-service/MemberService ';

@Component({
  selector: 'app-biweekly-report-history',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatPaginatorModule, MatPaginator, MatProgressSpinnerModule],
  templateUrl: './biweekly-report-history.component.html',
  styleUrl: './biweekly-report-history.component.css'
})
export class BiweeklyReportHistoryComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['reportGeneratedAt', 'dateRange', 'biweeklyReportUrl'];
  memberId: string = '';
  firstPage: number = 0;
  pageSize: number = 5;
  pageIndex: number = 0;
  totalRecords: number = 0;
  isLoading: boolean = false;

  constructor(
    private memberService: MemberService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('id') || '';
    if (this.memberId) {
      this.getBiweeklyReports(1);
    }
  }

  getBiweeklyReports(pageNo: number): void {
    this.isLoading = true;
    this.memberService.getBiweeklyReports(this.memberId, pageNo, this.pageSize).subscribe({
      next: (data: any) => {
        if (!data || !data.result || !data.result.biWeeklyReports) {
          this.dataSource = new MatTableDataSource<any>([]);
          this.totalRecords = 0;
          this.pageIndex = pageNo - 1;
          this.isLoading = false;
          return;
        }

        // Transform current page items
        const pageItems = data.result.biWeeklyReports.map((report: any) => ({
          reportGeneratedAt: report.createdDateTime,
          dateRange: {
            startDate: report.reportStartDate,
            endDate: report.reportEndDate
          },
          biweeklyReportUrl: `https://drive.google.com/file/d/${report.driveFileId}/view?usp=sharing`
        }));

        this.dataSource = new MatTableDataSource<any>(pageItems);
        this.totalRecords = data.totalCount ?? pageItems.length;
        this.pageIndex = pageNo - 1;
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Error fetching biweekly reports:', error);
        this.isLoading = false;
      }
    });
  }

  pageChangeEvent(page: any): void {
    this.getBiweeklyReports(page.pageIndex + 1);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const datePart = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true });

    return `${datePart} at ${timePart}`;
  }

  formatDateOnly(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  formatDateRange(startDate: string, endDate: string): string {
    const start = this.formatDateOnly(startDate);
    const end = this.formatDateOnly(endDate);
    return `${start} to ${end}`;
  }
}
